
<template>
    <ListDialog ref="SalesAnalyseDialog" :title="$parent.formatTitle('売上分析表')" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="SalesAnalyseReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【売上分析表】のデータを選択でき、初期値は×で消してから変更が可能です。" />
	      <NumericBox title="年度" :editor="editor" :value.sync="year" :required="true" min="1900" max="2999" :decimals="0" tooltip="帳票に出力する年度を選択します。年度開始の基準月は【マスタ設定】＞【システム設定】＞【年度開始月】で設定します。" />
        <RadioButton title="期間" :editor="editor" :value.sync="period" list="periodTypes" :required="true" tooltip="帳票に出力をする期間を選択します。上半期･下半期のどちらかを選択できます。年度開始月は【マスタ設定】＞【テナント設定】＞【年度開始月】で設定します。" />
        <RadioButton title="基準日" :editor="editor" :value.sync="searchDeliveryDate" list="salesReferenceDateTypes"/>
	      <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
        <AtcCounterpart title="得意先" :editor="editor" :value.sync="counterpart" :needsCustomer="true" tooltip="ここで得意先を選択をすると、選択した得意先だけのデータを出力する事ができます。選択しない場合はすべての得意先のデータが出力できます。" />
        <AtcCategory title="取引先区分" :categoryGroup="categoryGroupCounterpart" :value.sync="counterpartCategory" tooltip="ここで取引先区分を選択をすると、選択した区分だけのデータを出力する事ができます。選択しない場合はすべての区分のデータが出力できます。" />
        <AtcCommodity title="商品" :editor="editor" :value.sync="commodity" tooltip="ここで商品を選択をすると、選択した商品だけのデータを出力する事ができます。選択しない場合はすべての商品のデータが出力できます。" />
        <AtcCategory title="商品区分" :categoryGroup="categoryGroupCommodity" :value.sync="commodityCategory" tooltip="ここで商品区分を選択をすると、選択した区分だけのデータを出力する事ができます。選択しない場合はすべての区分のデータが出力できます。" />
        <AutoComplete title="明細区分" :editor="editor" :value.sync="itemCategory" list="salesAnalyseCategoryTypes" :required="true" tooltip="出力する集計表の集計基準を選択できます。ここで選択された区分毎に集計されたデータが出力されます。初期値は×で消してから変更することができます。" />
        <AutoComplete title="集計区分1" :editor="editor" :value.sync="summaryCategory1" list="salesAnalyseCategoryTypes" :required="summaryCategory2 != null" tooltip="出力する集計表の集計基準に､更に集計条件を追加する場合ここで選択します。各種区分1～6は【区分一覧】で登録する必要があります。" />
        <AutoComplete title="集計区分2" :editor="editor" :value.sync="summaryCategory2" list="salesAnalyseCategoryTypes" tooltip="出力する集計表の集計基準に､更に集計条件を追加する場合ここで選択します。各種区分1～6は【区分一覧】で登録する必要があります。" />
        <CheckBox title="集計対象" :editor="editor" :value.sync="includeProspectType" list="includeProspectTypes" tooltip="未売上の出荷や受注の売上見込を集計対象に含めることができます。売上見込の日付は出荷予定日で集計し、払出金額は【商品マスタ】の【仕入金額】を参照します。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>                        
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>            
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSalesAnalyse extends Vue {

  // 売上集計用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public year: number = null;
  public period: number = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public counterpartCategory: Common.Category = null;
  public categoryGroupCounterpart: Common.CategoryGroup = Common.CategoryGroup.Counterpart;
  public commodity: Common.Commodity = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public itemCategory: number = null;
  public summaryCategory1: number = null;
  public summaryCategory2: number = null;
  // public includeProspect: boolean = false;
  public tenantSetting: Common.TenantSettings = null;
  public onExcelExport :boolean = false;
  public searchDeliveryDate: boolean = false;
  public includeProspectType: Common.IncludeProspectTypes = Common.IncludeProspectTypes.None;

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.SalesAnalyseReportTemplateQuery = new Common.SalesAnalyseReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    this.tenantSetting = this.$api.tenantSettings; 
    var today:Date = new Date().getCalendarDate();
    if (this.tenantSetting.startMonth <= today.getMonth()+1) this.year = today.getFullYear();
    else this.year = today.getFullYear() -1; 
    
    var firstPeriod: Date = new Date(this.year, this.tenantSetting.startMonth + 5, 0).getCalendarDate();
    if (firstPeriod >= today) this.period = 0;
    else this.period = 1;

    (this.$refs.SalesAnalyseDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SalesAnalyseReportQuery = new Common.SalesAnalyseReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.year = this.year;
    query.month = this.tenantSetting.startMonth;
    query.period = this.period;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.counterpartCategory = this.counterpartCategory;
    query.commodity = this.commodity;
    query.commodityCategory = this.commodityCategory;
    query.itemCategory = this.itemCategory;
    if (this.summaryCategory1 == null) query.summaryCategory1 = 0;
    else query.summaryCategory1 = this.summaryCategory1;
    if (this.summaryCategory2 == null) query.summaryCategory2 = 0;
    else query.summaryCategory2 = this.summaryCategory2;
    // query.includeProspect = this.includeProspect;
    query.onExcelExport = this.onExcelExport;
    query.includeProspectType = this.includeProspectType;
    query.searchDeliveryDate = this.searchDeliveryDate;
    this.$api.download(query);
  }
}
</script>
